<template>
  <v-list :class="[{'mobile-styles': isMobileDevice}]">
    <v-list-item v-if="isMobileDevice">
      <v-spacer />

      <v-btn :ripple="false" icon class="close-btn" @click="toggleNavDrawer">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-list-item>

    <!-- PROFILE INFO ON SMALL DEVICES -->
    <!-- add logo here and also to AppProfile.vue, put logo files in /public/img/icons/ -->
    <div v-if="isMobileDevice" class="profile-info mx-6">
      <v-avatar size="34px" class="">
        <img v-if="avatar" :src="avatar" alt="name" />
        <img v-else-if="user.tenantId && user.tenantId.includes('lemeks')" src="/img/icons/lemeks-test-icon.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('salvest')" src="/img/icons/salvest-icon.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('estiko')" src="/img/icons/estiko-icon.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('demo2')" src="/img/icons/moodne-valgustus-icon.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('ekspressmeedia')" src="/img/icons/Delfi-yester.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('trimtex')" src="/img/icons/trimtex_icon.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('evocon')" src="/img/icons/evocon.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('salutaguse')" src="/img/icons/KOOS.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('pipelife')" src="/img/icons/eesti-optik-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('demo3')" src="/img/icons/tree-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('demo4')" src="/img/icons/tree-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('demo5')" src="/img/icons/tree-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('georgfischer')" src="/img/icons/Georg_Fischer_logo.svg.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('cristella')" src="/img/icons/verston-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('gospa')" src="/img/icons/gospa-logo.jfif"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('aripäev')" src="/img/icons/aripaev-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('incap')" src="/img/icons/incap-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('podiumnorth')" src="/img/icons/podiumnorth-square-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('merit')" src="/img/icons/merit-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('demo1')" src="/img/icons/elnet-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('programmable-equity')" src="/img/icons/KOOS.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('smart-accounts')" src="/img/icons/smart-accounts.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('trendsetter')" src="/img/icons/trendsetter.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('mercantile')" src="/img/icons/Mercantile-logo-200x58.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('weg')" src="/img/icons/WEG.jfif"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('linde-gas')" src="/img/icons/linde-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('scandagra')" src="/img/icons/scandagra-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('esteve')" src="/img/icons/esteve-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('operail')" src="/img/icons/operail-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId === 'er'" src="/img/icons/er-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('ouman')" src="/img/icons/ouman-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('puidukoda')" src="/img/icons/puidukoda-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('maxima')" src="/img/icons/maxima-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('rethinkers')" src="/img/icons/rethinkers-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('topauto')" src="/img/icons/topauto-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('projektiburoo')" src="/img/icons/projektiburoo-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('dhlexpressestonia')" src="/img/icons/dhl-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('beyond')" src="/img/icons/beyond-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('hobbyhall')" src="/img/icons/phh-group-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('plastone')" src="/img/icons/plastone-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('stebby')" src="/img/icons/stebby-logo.jfif"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('kaup24')" src="/img/icons/kaup24-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('tammer')" src="/img/icons/tammer-logo.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('juunika')" src="/img/icons/juunika-logo.jfif"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('hydroscand')" src="/img/icons/hydroscand-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('taavitarkvara')" src="/img/icons/taavi-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('johvihaigla')" src="/img/icons/johvihaigla-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('corrigo')" src="/img/icons/corrigo-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('projekt363')" src="/img/icons/projekt363-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('noto')" src="/img/icons/noto-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('demo6')" src="/img/icons/demo6-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('accelerando')" src="/img/icons/accelerando-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('astlanda')" src="/img/icons/astlanda-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('lightcodephotonics')" src="/img/icons/lightcodephotonics-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('saint-gobain')" src="/img/icons/saintgobain-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('torisawmill')" src="/img/icons/torisawmill-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('navix')" src="/img/icons/navix-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('treffex')" src="/img/icons/treffex-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('autospirit')" src="/img/icons/autospirit-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('svtrading')" src="/img/icons/svtrading-logo.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('airestakstiaselts')" src="/img/icons/airest-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('ascartartu')" src="/img/icons/ascartartu-logo.PNG"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('expressline')" src="/img/icons/expressline-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('taavidemo')" src="/img/icons/taavidemo-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('hotelltelegraaf')" src="/img/icons/hotelltelegraaf-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('pharmapark')" src="/img/icons/pharmapark-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('mehkaeesti')" src="/img/icons/mehka-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('gscan')" src="/img/icons/gscan-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('paljassaare')" src="/img/icons/paljassaare-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('cleveron')" src="/img/icons/cleveron-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('lindstrom')" src="/img/icons/lindstrom-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('bauroc')" src="/img/icons/bauroc-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('3stepit')" src="/img/icons/3stepit-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('digitrukk')" src="/img/icons/digitrukk-logo.svg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('tartuagro')" src="/img/icons/tartuagro-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('klipmarine')" src="/img/icons/klipmarine-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('raumedic')" src="/img/icons/raumedic-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('tostamaa')" src="/img/icons/tostamaa-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('terviseagentuur')" src="/img/icons/terviseagentuur-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('wendre')" src="/img/icons/wendre-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('fontes')" src="/img/icons/fontes-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('figure')" src="/img/icons/fontes-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('vbhestonia')" src="/img/icons/vbhestonia-logo.jpeg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('estoniancell')" src="/img/icons/estoniancell-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('basfuab')" src="/img/icons/basfuab-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('estoniaou')" src="/img/icons/estoniaou-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('werkukohvik')" src="/img/icons/werkukohvik-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('arroagasild')" src="/img/icons/arroagasild-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('fairownholding')" src="/img/icons/fairownholding-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('mobiregroup')" src="/img/icons/mobire-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('viciunaibaltic')" src="/img/icons/viciunaibaltic.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('puumarket')" src="/img/icons/puumarket.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('volvoestonia')" src="/img/icons/volvoestonia.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('bdoeesti')" src="/img/icons/bdoeesti.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('inseneriburootelora')" src="/img/icons/inseneriburootelora.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('afterone')" src="/img/icons/afterone.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('baltiautoosad')" src="/img/icons/baltiautoosad.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('starklogistics')" src="/img/icons/startlogistics.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('rapinapaberivabrik')" src="/img/icons/rappin.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('ignitiseesti')" src="/img/icons/ignitis-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('ahhaateaduskeskus')" src="/img/icons/ahhaateaduskeskus-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('efta')" src="/img/icons/efta-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('vikinglineeesti')" src="/img/icons/vikingline-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('kone')" src="/img/icons/kone-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('alaskuul')" src="/img/icons/alaskuul-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('zetesestonia')" src="/img/icons/zetes-logo.jpg"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('optimeraestonia')" src="/img/icons/optimeraestonia-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('saueproduction')" src="/img/icons/solina-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('scametsadeesti')" src="/img/icons/scametsadeesti-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('afg')" src="/img/icons/afg-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('krattworks')" src="/img/icons/krattworks-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('addinol')" src="/img/icons/addinol-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('scamezslatvija')" src="/img/icons/scamezslatvija-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('stadaestonia')" src="/img/icons/stadaestonia-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('viimsihaldus')" src="/img/icons/viimsihaldus-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('silmanielekter')" src="/img/icons/silmanielekter-logo.png"
             alt="name"
        >
        <img v-else-if="user.tenantId && user.tenantId.includes('tesronehitus')" src="/img/icons/tesronehitus-logo.png"
             alt="name"
        >
        <v-icon v-else x-large color="#00072B">
          mdi-account
        </v-icon>
      </v-avatar>
      <div class="nav-user-info">
        <p class="mt-4 mb-0 pb-0">
          {{ user.name }}
        </p>
        <div class="profile-options">
          <p class="subtitle mt-0 pt-0">
            {{ $t(user.tenantId) }}
          </p>
          <v-btn icon class="pt-0 no-ripple-background" :ripple="false" small @click="toggleCompanyMenu">
            <v-icon class="pa-0" color="#00072B">
              {{ isCompanyMenuOpened ? 'mdi-menu-up' : 'mdi-menu-down' }}
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <v-divider v-if="isMobileDevice" class="my-3 nav-divider" />

    <div v-if="isMobileDevice && isCompanyMenuOpened" class="tenant-menu-content pl-6">
      <p class="mt-0 pt-0">
        {{ $t(user.tenantId) }}
      </p>
    </div>

    <v-divider v-if="isMobileDevice && isCompanyMenuOpened" class="mt-3 mb-2 nav-divider" />

    <v-list-item
      v-for="(item, index) in navItems"
      :key="item.name"
      v-ripple="false"
      :to="resolvePath(item)"
      class="nav-drawer-link"
      :class="{active: isActive(item)}"
      active-class="active"
    >
      <v-list-item-icon class="Item">
        <v-icon v-if="index > 0">
          {{ getListIcon(item) }}
        </v-icon>

        <img
          v-else
          src="/img/icons/yester_icon_BLUE_GREEN.svg"
          alt="Yester"
          width="100%"
          class="v-icon"
        />
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>
          {{ getListTitle(item) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      v-for="(item, index) in menuitems"
      v-show="isMobileDevice"
      :key="index"
      :to="null"
      href="#"
      rel="noopener"
      class="logout-item nav-drawer-link"
      @click="item.click"
    >
      <v-list-item-icon>
        <v-icon>
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>
          {{ $t(item.title) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-dialog v-model="profileDialog" max-width="90%" v-bind="getMobileDialogProps">
      <user-profile :dialog-opened="profileDialog" class="test" @close="closeDialog" />
    </v-dialog>

    <v-dialog v-model="passwordDialog" max-width="90%" v-bind="getMobileDialogProps">
      <password-dialog :dialog-opened="passwordDialog" @close="closeDialog" />
    </v-dialog>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';

import UserProfile from '@/views/widget/AppUserProfile.vue';
import PasswordDialog from '@/views/widget/AppUserPassword.vue';
import { resolve } from '@/router/utils';

export default {
  name: 'TheLayoutNavigationList',
  components: {
    UserProfile,
    PasswordDialog,
  },
  props: {
    dense: Boolean,
    routes: {
      type: Array,
      default: () => {},
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      profileDialog: false,
      passwordDialog: false,
      isCompanyMenuOpened: false,
      menuitems: [
        {
          icon: 'mdi-account-circle',
          href: '#',
          title: 'toolbar.profile',
          click: () => {
            this.profileDialog = true;
          },
        },
        {
          icon: 'mdi-lock',
          href: '#',
          title: 'toolbar.changePassword',
          click: () => {
            this.passwordDialog = true;
          },
        },
        {
          icon: 'mdi-logout',
          href: '#',
          title: 'toolbar.logout',
          click: () => {
            this.logout();
          },
        },
      ],
    };
  },
  computed: {
    navItems() {
      let arr = this.routes.filter((route) => !route.hidden && !['RecordFormWebView', 'FormWebView'].includes(route.name));
      if (this.isMobileDevice) {
        arr = this.routes.filter((route) => !route.hidden && !['RecordFormWebView', 'FormWebView', 'Settings'].includes(route.name));
      }
      return arr;
    },
    ...mapGetters(['user', 'name', 'avatar']),
    getMobileDialogProps() {
      let props = {
      };
      if (this.isMobileDevice) {
        props = {
          fullscreen: true,
          hideOverlay: true,
          transition: 'dialog-bottom-transition',
        };
      }
      return props;
    },
  },
  methods: {
    toggleNavDrawer() {
      this.$emit('toggle-nav-drawer');
    },
    toggleCompanyMenu() {
      this.isCompanyMenuOpened = !this.isCompanyMenuOpened;
    },
    logout() {
      this.$store.dispatch('LogOut');
    },
    closeDialog() {
      this.profileDialog = false;
      this.passwordDialog = false;
    },
    getListIcon(item) {
      if (item.children.length === 1 && item.children[0].meta && item.children[0].meta.icon) {
        return item.children[0].meta.icon;
      }
      return item.meta.icon;
    },
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path);
    },
    isActive(item) {
      let active = false;
      if (item.name) {
        active = this.$route.path.startsWith(
          `/${item.name.toLocaleLowerCase()}`,
        );
      }

      return active;
    },
    getListTitle(item) {
      return item.meta ? this.$t(item.meta.title) : '';
    },
    resolvePath(item) {
      if (this.isExternal(item.path)) {
        return item.path;
      }

      let path = '';

      if (item.children.length >= 1) {
        path = resolve(item.path, item.children[0].path);
      }

      return path;
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  > *:first-child {
    &:after {
      content: "";
      position: relative;
      top: -5px;
      left: -37px;
      min-width: 42px;
      height: 42px;
      border: 2px solid #6fff81;
      border-radius: 10px;
    }
  }
}
.v-list-item {
  padding-left: 12px !important;
}
.v-list-item--link:before {
  background: none;
}
.Item {
  background-color: $yester-lila-light;
  min-height: 32px;
  padding: 0;
  border-radius: 6px;
  min-width: 32px;
  width: 32px;
  height: 32px;
  margin: 10px 14px;
  margin-left: 0px !important;
  margin-right: 20px !important;

  &.v-list-item--active {
    margin: 10px 14px;
  }

    .v-icon {
      min-width: 32px;
      width: 32px;
    }

  .v-list-item__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

  }
}

.close-btn {
  & .v-icon {
    color: $yester-dark;
  }
}

// RESPONSIVENESS
.mobile-styles {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100% !important;
  .nav-drawer-link {
    margin-left: 10px;
    margin-right: 10px;
    & .v-list-item__title {
      color: rgba(0, 0, 0, 0.6);
      font-weight: 500;
    }
  }
  .logout-item {
    padding-top: 0px !important;
    & .v-list-item__icon {
      margin-right: 20px !important;
    }
    .Item {
      background-color: #fff;
      margin-right: 0px !important;
      .v-icon {
        color: rgba(0, 0, 0, 0.6) !important;
        font-size: 20px !important;
      }
    }
  }
  .active {
    background: rgba(196, 196, 196, 0.3);
    border-radius: 4px;
    & .v-list-item__title {
      color: $yester-lila-light;
    }
    > *:first-child {
      &:after {
       display: none;
      }
    }
  }
  .Item {
    min-height: 25px;
    min-width: 25px;
    width: 25px;
    height: 25px;
    .v-icon {
      min-width: 25px !important;
      width: 25px !important;
      font-size: 15px;
      color: #fff !important;
    }
  }

  .profile-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: calc(100% - 35px);
  }
  .tenant-menu-content {
    p {
      color: $yester-dark;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
    }
  }
  .nav-user-info {
    p {
      &:first-of-type {
        font-weight: 500;
        font-size: 20px;
        line-height: 1;
      }
      &.subtitle {
        color: rgba(0, 0, 0, 0.6);
        font-weight: 400;
        font-size: 14px;
        line-height: 1;
        margin-top: 5px !important;
      }
    }
    width: 100%;
  }
  .profile-options {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 20px;
    .v-icon {
      width: 20px;
      height: 15px;
      margin-top: 0px;
    }
  }
  .nav-divider {
    border-color: $yester-dark-grey !important;
  }
}
</style>
